import React from "react";
import moment from "moment";
import Modal, { ModalButton } from "common/modal";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface ReactivateTrialPackageModalProps {
  loading: boolean;
  visible: boolean;
  endDate: Date;
  onConfirm: () => void;
  onCancel: () => void;
}

const ModalText = styled.div`
  margin: 8px 0px 12px;
  font-size: 18px;
  color: #282828;
`;

const ReactivateTrialPackageModal = ({
  loading,
  visible,
  endDate,
  onConfirm,
  onCancel,
}: ReactivateTrialPackageModalProps) => {
  const { t } = useTranslation("my_credits");
  const endTime = moment(new Date(endDate)).format("MMM DD, YYYY") || "";

  return (
    <Modal
      title={t("REACTIVATE PACKAGE")}
      visible={visible}
      onCancel={onCancel}
    >
      <ModalText>
        {t(
          "Do you want to re-activate your trial package? You will receive your credits and be charged on "
        )}
        {endTime}
        {t(
          ". You will not be charged now. To buy credits right now, scroll up to buy additional credits, sign up for a subscription or buy a package."
        )}
      </ModalText>

      <br />

      <ModalButton onClick={() => onCancel()}>{t("CANCEL")}</ModalButton>
      <ModalButton loading={loading} onClick={() => onConfirm()}>
        {t("REACTIVATE IT")}
      </ModalButton>
    </Modal>
  );
};

export default ReactivateTrialPackageModal;
